// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2gcbC","title":"ClientReferral_title__1JLrC","itemText":"ClientReferral_itemText__3K-Ll"};